const toastr = require('toastr');
const constants = require('shared/helpers/constants');

// Unlike the uploader, which we use outside standardUploaderView, we don't invoke toastr anywhere outside notify. So it makes more sense to have the defaults here. 
// The following animation properties have no discernible affect on how toasts appear when using fadeIn/fadeOut methods
// - showDuration
// - hideDuration
const defaultOptions = {
    timeOut: 5000,
    preventDuplicates: true,
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    onclick: null,
    positionClass: 'toast-top-right'
};

// - Stays longer than normal. 
// - Top screen, full width. 
const errorDefaultOptions = {
    timeOut: 10000,
    extendedTimeOut: 1000,
    positionClass: 'toast-top-full-width'
};

module.exports = {
    notifyError: function (msg, toastrOptions) {
        toastr.options = { ...defaultOptions, ...errorDefaultOptions, ...toastrOptions };
        toastr.error(msg);
    },

    notifySuccess: function (msg, toastrOptions) {
        toastr.options = { ...defaultOptions, ...toastrOptions };
        toastr.success(msg);
    },

    notifyWarning: function (msg, toastrOptions) {
        toastr.options = { ...defaultOptions, ...toastrOptions };
        toastr.warning(msg);
    },

    notifyInfo: function (msg, toastrOptions) {
        toastr.options = { ...defaultOptions, ...toastrOptions };
        toastr.info(msg);
    },

    notifyClear: function () {
        toastr.clear();
    }
};